// extracted by mini-css-extract-plugin
module.exports = {"box":"Login_box__2RxxX","anime":"Login_anime__NdTXU","inputBox":"Login_inputBox__toqHI","error":"Login_error__3bSZ3"};